import React from 'react';
import NoData from 'ui-components/NoData';
import NoReportsIcon from 'ui-components/icons/NoReportsIcon';

// Reports empty state, built on the shared NoData component so it matches every
// other empty screen (icon centred above the title + subtitle). The gradient
// folder mark is passed as the placeholder icon.
// `height` is forwarded so a caller can shorten the block on small screens - NoData's
// 60dvh default is a lot of empty space once a page adds its own card padding around it.
const NoReports = ({ height, sx = {} }) => (
    <NoData
        placeHolderImage={NoReportsIcon}
        title="No Reports"
        subTitle=""
        {...(height ? { height } : {})}
        sx={sx}
    />
);

export default NoReports;
